import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import type { TOverrideBreakpoints } from '../components/ViewerQnA/constants';

export interface IInheritColors {
  primary: string;
  accentHover: string;
  iconTextColor: string;
  backgroundColor: string;
  textHoverColor: string;
}

interface IUIState {
  // State
  overrideBreakpoint?: TOverrideBreakpoints;
  inheritColors?: IInheritColors | null;

  // Actions
  initializeUIStore: (
    inheritColors?: IInheritColors | null,
    overrideBreakpoint?: TOverrideBreakpoints,
  ) => void;
  setOverrideBreakpoint: (overrideBreakpoint?: TOverrideBreakpoints) => void;
  setInheritColors: (inheritColors?: IInheritColors | null) => void;
  reset: () => void;
}

const initialStoreState: {
  overrideBreakpoint?: TOverrideBreakpoints;
  inheritColors?: IInheritColors | null;
} = {
  overrideBreakpoint: undefined,
  inheritColors: null,
};

export const useUIStore = create<IUIState>()(
  devtools(
    (set) => ({
      // Initial State
      ...initialStoreState,

      // Actions
      initializeUIStore: (
        inheritColors?: IInheritColors | null,
        overrideBreakpoint?: TOverrideBreakpoints,
      ) => {
        set(() => ({ inheritColors, overrideBreakpoint }), undefined, 'ui/initializeUIStore');
      },

      setOverrideBreakpoint: (overrideBreakpoint) =>
        set(() => ({ overrideBreakpoint }), undefined, 'ui/setOverrideBreakpoint'),

      setInheritColors: (inheritColors) =>
        set(() => ({ inheritColors }), undefined, 'ui/setInheritColors'),

      reset: () => set(() => initialStoreState, undefined, 'ui/reset'),
    }),
    {
      name: 'UIStore',
      enabled: process.env.NODE_ENV !== 'production' && typeof window !== 'undefined',
    },
  ),
);
